export default function (el, { classPrefix = 'sticky', parentNode = null }) {
  function setDimensions() {
    const boundingClientRect = el.getBoundingClientRect();

    spacer.style.width = boundingClientRect.width + 'px';
    spacer.style.height = boundingClientRect.height + 'px';

    stopper.style.height = boundingClientRect.height + 'px';
  }

  let sticky = false;
  let contain = false;

  function update() {
    if (contain) {
      el.style.position = 'absolute';
    } else if (sticky) {
      el.style.position = 'fixed';
    } else {
      el.style.position = 'absolute';
    }

    if (contain) {
      el.style.top = null;
      el.style.bottom = 0;
      wrapper.style.position = null;
      parentNode.style.position = 'relative';
    } else {
      el.style.top = 0;
      el.style.bottom = null;
      wrapper.style.position = 'relative';
      parentNode.style.position = null;
    }

    el.classList.toggle(classPrefix + '-stickied', sticky);
  }

  if (null === parentNode) {
    parentNode = el.parentNode;
  }

  const wrapper = document.createElement('div');
  wrapper.className = classPrefix + '-wrapper';
  wrapper.style.position = 'relative';

  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);

  // The spacer element maintains the physical space
  // of the target element to avoid page jumps.
  const spacer = document.createElement('div');
  spacer.className = classPrefix + '-spacer';

  // The stopper element is placed at the bottom of the parentNode.
  // The stopper is the same height as the target element.
  // When the stopper goes out of the top of the viewport,
  // it means the target element should be contained.
  const stopper = document.createElement('div');
  stopper.className = classPrefix + '-stopper';
  stopper.style.position = 'absolute';
  stopper.style.bottom = 0;
  stopper.style.left = 0;
  stopper.style.right = 0;
  stopper.style.zIndex = -1;

  parentNode.appendChild(stopper);

  setDimensions();

  el.style.position = 'absolute';
  el.style.top = 0;
  wrapper.appendChild(spacer);

  const resizeObserver = new ResizeObserver((entries) => {
    setDimensions();
  });

  resizeObserver.observe(el);

  const spacerObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        sticky = entry.boundingClientRect.y < 0;

        update();
      });
    },
    { threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0] }
  );

  spacerObserver.observe(spacer);

  const stopperObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        contain = entry.boundingClientRect.y < 0;

        update();
      });
    },
    { threshold: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0] }
  );

  stopperObserver.observe(stopper);
}
